(function () {
  if (window.__ltsLoopInit) return;
  window.__ltsLoopInit = true;
  function init() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-lts-loop]').forEach(function (wrap) {
      if (wrap.__ltsReady) return;
      wrap.__ltsReady = true;
      var v = wrap.querySelector('video');
      var b = wrap.querySelector('.lts-loop__sound');
      if (!v) return;
      v.muted = true;
      v.loop = true;
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      if (reduce) {
        v.removeAttribute('autoplay');
        v.pause();
        v.controls = true;
        if (b) b.hidden = true;
        return;
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
            else { v.pause(); }
          });
        }, { threshold: 0.5 }).observe(wrap);
      }
      if (b) {
        b.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          v.muted = !v.muted;
          b.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
          b.setAttribute('aria-label', v.muted ? 'Turn sound on' : 'Turn sound off');
          if (!v.muted) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
